import VueQuagga from 'vue-quaggajs';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(VueQuagga);
});